import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableMasrufat from "./ScroollTableMasrufat";
import FooterOfMasrufat from "./FooterOfMasrufat";
import FillDetailMasrufat from "./FillDetailMasrufat";
const AllMasrufat = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailMasrufat />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScroollTableMasrufat />
          </div>
        </div>
        <div className="row " style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 col-12">
            <FooterOfMasrufat />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllMasrufat;
